export const SET_SEC_LEVEL = 'SET_SEC_LEVEL';
export const RESET_SEC_LEVEL = 'RESET_SEC_LEVEL';
